import dayjs from 'dayjs';

import { ICliente } from 'app/shared/model/cliente.model';

export interface IMensaje {
  id?: number;
  nombreCliente?: string | null;
  numeroCelular?: string | null;
  referencia?: number;
  concepto?: string;
  monto?: number;
  timestampLimite?: dayjs.Dayjs | null;
  timestampSolicitud?: dayjs.Dayjs;
  idMensajeCobro?: string | null;
  edoPet?: number | null;
  extra1?: string | null;
  extra2?: string | null;
  extra3?: string | null;
  extra4?: string | null;
  extra5?: string | null;
  extra6?: string | null;
  extra7?: string | null;
  extra8?: string | null;
  extra9?: string | null;
  extra10?: string | null;
  createdBy?: string | null;
  createdDate?: dayjs.Dayjs | null;
  lastModifiedBy?: string | null;
  lastModifiedDate?: dayjs.Dayjs | null;
  cliente?: ICliente | null;
}

export const defaultValue: Readonly<IMensaje> = {};
